const map = {
	"./Choose your target Audience.png": 23077,
	"./DIGITAL-NOTICE-BOARD.png": 26506,
	"./DIGITAL-NOTICE-BOARD_.png": 13463,
	"./Easy-Scheduling.png": 18523,
	"./Easy-Scheduling_.png": 45588,
	"./Further Segregation.png": 802,
	"./Manage-Segregation.png": 29148,
	"./Manage-Segregation_.png": 59265,
	"./Publish-Instantly.png": 77986,
	"./Publish-Instantly_.png": 36975,
	"./Schedule Notices with Ease.png": 85458,
	"./image11.png": 83187,
	"./image11_.png": 33100,
	"./image15.png": 93367,
	"./image15_.png": 53008,
	"./image75.png": 9521,
	"./image75_.png": 9986,
	"./improve Communication.png": 39158
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61022;